import React, { useEffect } from "react";
import { Button, Col, Container, Row, Tab, Tabs, Nav } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Dropzone from "../../../../components/Dropzone/Dropzone";
import { MdAdd, MdDelete } from "react-icons/md";
import toast from "react-hot-toast";
import { useUpdateHomePageMutation } from "../../../../store/services/HomePageContentService";
import CKEditorNew from "../../../../components/newCkEditor/ckEditor";
//import CKEditorField from "../../../../components/ckEditor/CKEditorField";

function HomepageContentForm({ data }) {
  const [updateHomePage, { isLoading: isUpdating }] =
    useUpdateHomePageMutation();
  const { createdAt, updatedAt, ...PageInfo } = data;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "onTouched",
    defaultValues: { ...PageInfo },
  });
  const {
    fields: offerFields,
    append: appendOffer,
    remove: removeOffer,
  } = useFieldArray({
    control,
    name: "offer.offerList",
  });

  const {
    fields: stepFields,
    append: appendStep,
    remove: removeStep,
  } = useFieldArray({
    control,
    name: "howItWorks.stepWork",
  });

  const {
    fields: stepFooter,
    append: appendFooter,
    remove: removeFooter,
  } = useFieldArray({
    control,
    name: "footer.atmCard",
  });

  const {
    fields: cardFields,
    append: appendCard,
    remove: removeCard,
  } = useFieldArray({
    control,
    name: "whyChooseUs.card",
  });

  const {
    fields: featureFields,
    append: appendFeature,
    remove: removeFeature,
  } = useFieldArray({
    control,
    name: "letCompare.featureList",
  });

  const {
    fields: imageFields,
    append: appendImage,
    remove: removeImage,
  } = useFieldArray({
    control,
    name: "letCompare.imageSection",
  });

  const {
    fields: listFields,
    append: appendList,
    remove: removeList,
  } = useFieldArray({
    control,
    name: "kitchenDelivery.list",
  });

  const {
    fields: weekFields,
    append: appendWeek,
    remove: removeWeek,
  } = useFieldArray({
    control,
    name: "kitchenDelivery.week",
  });

  const {
    fields: testimonialFields,
    append: appendTestimonial,
    remove: removeTestimonial,
  } = useFieldArray({
    control,
    name: "testimonial.testimonial",
  });

  const {
    fields: iconFields,
    append: appendSubIcon,
    remove: removeSubIcon,
  } = useFieldArray({
    control,
    name: "subscribe.followUs.socialIcon",
  });

  const {
    fields: sectionFirstFields,
    append: appendSectionFirst,
    remove: removeSectionFirst,
  } = useFieldArray({
    control,
    name: "sectionFirst",
  });

  const {
    fields: partnerFields,
    append: appendPartner,
    remove: removePartner,
  } = useFieldArray({
    control,
    name: "trustedPartners.partners",
  });


  const onSubmit = async (data) => {
    const icons = data?.subscribe?.followUs?.socialIcon;

    if (Array.isArray(icons)) {
      data.subscribe.followUs.socialIcon = icons.map(item => ({
        ...item,
        icon: Array.isArray(item?.icon) ? item.icon[0] : item?.icon
      }));
    }


    try {
      await updateHomePage({
        updatedData: data,
      });
      return toast.success(`Setting updated successfully`);
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  useEffect(() => {
    let toastId;

    if (isUpdating) {
      // Show loading toast and save the ID
      toastId = toast.loading("Updating...");
    } else if (toastId) {
      // Dismiss the loading toast when isUpdating is false
      toast.dismiss(toastId);
    }

    return () => {
      // Cleanup: Ensure toast is dismissed if the component unmounts
      if (toastId) {
        toast.dismiss(toastId);
      }
    };
  }, [isUpdating]);

  console.log("listFields ============>", iconFields);


  return (
    <Col lg="12" md="12" sm="12" className="my-2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="formWrpper px-lg-5 p-md-4 p-3 rounded"
          style={{ background: "#EEEEEE" }}
        >
          <Row className="justify-content-between">

            <Col lg="12">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="header"
              >

                <Nav
                  variant="pills"
                  className="inline-flex pillsTab gap-10 pb-2"
                  style={{
                    // background: "#033E8A",
                    maxWidth: "max-content",
                  }}
                >
                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="header"
                    >
                      Header Section
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="slider-limit"
                    >
                      Slider Speed Limit
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="firstSection"
                    >
                      First Section
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="howItWorks"
                    >
                      How It Works
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="whyChooseUs"
                    >
                      Why Choose Us
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="compare"
                    >
                      Let's Compare
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="kitchenDelivery"
                    >
                      Kitchen Delivery
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="customerTestimonials"
                    >
                      Customer Testimonials
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="socialMedia"
                    >
                      Follow Us On Social Media
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="newsLetter"
                    >
                      Subscribe To Our Newsletter
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="footerSettings"
                    >
                      Footer Settings
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                      eventKey="trustedPartners"
                    >
                      Trusted Partners
                    </Nav.Link>
                  </Nav.Item>

                </Nav>

                <Tab.Content className="pt-3">

                  <Tab.Pane eventKey="header">
                    <Row>
                      <Col lg="6" md="6" sm="12" className="mb-3">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Logo
                          </label>
                          <Controller
                            name="logo"
                            control={control}
                            rules={{ required: "Please upload a logo" }}
                            render={({ field }) => (
                              <Dropzone
                                field="logo"
                                setFieldValue={setValue}
                                value={field.value}
                                error={errors}
                              />
                            )}
                          />
                          {errors.logo && (
                            <span className="text-danger">{errors.logo.message}</span>
                          )}
                        </div>
                      </Col>
                      <Col lg="6" md="6" sm="12" className="my-2">
                        {/* Name Field */}
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Logo Title
                          </label>
                          <input
                            type="text"
                            name="title"
                            {...register("logoTitle", {
                              required: "Please enter logo title",
                            })}
                            className="form-control"
                          />

                          {errors.logoTitle && (
                            <span className="text-danger">
                              {errors.logoTitle.message}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Header Offer's
                        </h4>
                      </Col>
                      <Col lg="12" md="12" sm="12" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Offer Title
                          </label>
                          <input
                            type="text"
                            {...register("offer.offerTitle", {
                              required: "Please enter offer title",
                            })}
                            className={`form-control ${errors?.offer?.offerTitle ? "is-invalid" : ""
                              }`}
                          />
                          {errors?.offer?.offerTitle && (
                            <span className="text-danger">
                              {errors?.offer?.offerTitle?.message}
                            </span>
                          )}
                        </div>
                      </Col>
                      {offerFields.map((field, index) => (
                        <div key={field.id} className="row">
                          {/* Image Field with Dropzone */}
                          <Col lg="6" md="6" sm="12" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Offer Image
                              </label>
                              <Controller
                                name={`offer.offerList.${index}.image`}
                                control={control}
                                rules={{ required: "Please upload an image" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`offer.offerList.${index}.image`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.offer?.offerList?.[index]?.image}
                                  />
                                )}
                              />
                              {errors?.offer?.offerList?.[index]?.image && (
                                <span className="text-danger">
                                  {errors?.offer?.offerList[index].image.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Description Field */}
                          <Col lg="6" md="6" sm="12" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Offer Description
                              </label>
                              <input
                                type="text"
                                placeholder="Enter offer description"
                                {...register(`offer.offerList.${index}.desc`, {
                                  required: "Please enter offer description",
                                })}
                                className={`form-control ${errors?.offer?.offerList?.[index]?.desc
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors?.offer?.offerList?.[index]?.desc && (
                                <span className="text-danger">
                                  {errors?.offer?.offerList[index].desc.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Remove Button */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeOffer(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}

                      {/* Add Offer Button */}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => appendOffer({ image: "", desc: "" })}
                        >
                          <MdAdd style={{ marginBottom: "2px" }} />
                          Add offer
                        </Button>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="slider-limit">
                    <Row>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Slider Speed Limit
                        </h4>
                      </Col>

                      <Col lg="6" md="6" sm="12" className="my-2">
                        {/* Name Field */}
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Slider Speed (Milli second)
                          </label>
                          <input
                            placeholder="Enter slider speed limit"
                            type="number"
                            name="sliderSpeed"
                            {...register("sliderSpeed",
                              // {
                              //   required: "Please enter logo title",
                              // }
                            )}
                            className="form-control"
                          />

                          {errors.logoTitle && (
                            <span className="text-danger">
                              {errors.logoTitle.message}
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="firstSection">
                    <Row>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          First Section
                        </h4>
                      </Col>

                      {sectionFirstFields.map((field, index) => (
                        <div key={field.id} className="row">

                          {/* Title Field */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                First section title
                              </label>
                              <input
                                type="text"
                                {...register(`sectionFirst.${index}.title`, {
                                  required: "Please enter first section title",
                                })}
                                className={`form-control ${errors?.sectionFirst?.[index]?.title
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors?.sectionFirst?.[index]?.title && (
                                <span className="text-danger">
                                  {errors?.sectionFirst?.[index]?.title.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Description Field */}
                          {/* <Col lg="6" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      First section description
                    </label>
                    <textarea
                      type="text"
                      {...register(`sectionFirst.${index}.desc`, {
                        required: "Please enter First section description",
                      })}
                      className={`form-control ${errors?.sectionFirst?.[index]?.desc
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {errors?.sectionFirst?.[index]?.desc && (
                      <span className="text-danger">
                        {errors?.sectionFirst?.[index]?.desc.message}
                      </span>
                    )}
                  </div>
                </Col> */}

                          <Col lg="6" md="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                First section description
                              </label>

                              <Controller
                                name={`sectionFirst.${index}.desc`}
                                control={control}
                                rules={{ required: "Please enter a first section description" }}
                                render={({ field }) => (
                                  <CKEditorNew
                                    field={field.name}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.sectionFirst?.[index]?.desc}
                                    placeholder="Type your description here..."
                                  />
                                )}
                              />

                              {errors?.sectionFirst?.[index]?.desc && (
                                <span className="text-danger">
                                  {errors.sectionFirst[index].desc.message}
                                </span>
                              )}
                            </div>
                          </Col>


                          {/* Image Field with Dropzone */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                First section banner image
                              </label>
                              <Controller
                                name={`sectionFirst.${index}.bannerImage`}
                                control={control}
                                rules={{ required: "Banner image is required" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`sectionFirst.${index}.bannerImage`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.sectionFirst?.[index]?.bannerImage}
                                  />
                                )}
                              />
                              {errors?.sectionFirst?.[index]?.bannerImage && (
                                <span className="text-danger">
                                  {errors?.sectionFirst?.[index].bannerImage.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                First section button text
                              </label>
                              <input
                                type="text"
                                {...register(`sectionFirst.${index}.btnText`, {
                                  required: "Please enter first section button text",
                                })}
                                className={`form-control ${errors?.sectionFirst?.[index]?.btnText
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors?.sectionFirst?.[index]?.btnText && (
                                <span className="text-danger">
                                  {errors?.sectionFirst?.[index]?.btnText.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Remove Button */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeSectionFirst(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => appendSectionFirst({ bannerImage: "", btnText: "", desc: "", title: "" })}
                        >
                          <MdAdd style={{ marginBottom: "2px" }} />
                          Section
                        </Button>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  {/* <Col lg="6" md="6" sm="12" className="mb-3">
                    <div className="py-2">
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Section Title
                      </label>
                      <input
                        type="text"
                        {...register("sectionFirst.title", {
                          required: "Title is required",
                        })}
                        className={`form-control ${errors.sectionFirst?.title ? "is-invalid" : ""
                          }`}
                      />
                      {errors.sectionFirst?.title && (
                        <span className="text-danger">
                          {errors.sectionFirst.title.message}
                        </span>
                      )}
                    </div>
                  </Col> */}

                  {/* Section First: Description */}
                  {/* <Col lg="6" md="6" sm="12" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                  Section Description
                </label>
                <input
                  type="text"
                  {...register("sectionFirst.desc", {
                    required: "Description is required",
                  })}
                  className={`form-control ${
                    errors.sectionFirst?.desc ? "is-invalid" : ""
                  }`}
                />
                {errors.sectionFirst?.desc && (
                  <span className="text-danger">
                    {errors.sectionFirst.desc.message}
                  </span>
                )}
              </div>
                   </Col> */}

                  {/* Section First: Banner Image */}
                  {/* <Col lg="6" md="6" sm="12" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                  Banner Image
                </label>
                <Controller
                  name="sectionFirst.bannerImage"
                  control={control}
                  rules={{ required: "Banner image is required" }}
                  render={({ field }) => (
                    <Dropzone
                      field="sectionFirst.bannerImage"
                      setFieldValue={setValue}
                      value={field.value}
                      error={errors.sectionFirst?.bannerImage}
                    />
                  )}
                />
                {errors.sectionFirst?.bannerImage && (
                  <span className="text-danger">
                    {errors.sectionFirst.bannerImage.message}
                  </span>
                )}
              </div>
                    </Col> */}

                  {/* Section First: Button Text */}
                  {/* <Col lg="6" md="6" sm="12" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                  Button Text
                </label>
                <input
                  type="text"
                  {...register("sectionFirst.btnText", {
                    required: "Button text is required",
                  })}
                  className={`form-control ${
                    errors.sectionFirst?.btnText ? "is-invalid" : ""
                  }`}
                />
                {errors.sectionFirst?.btnText && (
                  <span className="text-danger">
                    {errors.sectionFirst.btnText.message}
                  </span>
                )}
              </div>
                  </Col> */}

                  <Tab.Pane eventKey="howItWorks">
                    <Row>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          How It Works Section
                        </h4>
                      </Col>
                      {/* How It Works: Banner Image */}
                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            How It Works Banner Image
                          </label>
                          <Controller
                            name="howItWorks.bannerImage"
                            control={control}
                            rules={{ required: "Please enter banner image" }}
                            render={({ field }) => (
                              <Dropzone
                                field="howItWorks.bannerImage"
                                setFieldValue={setValue}
                                value={field.value}
                                error={errors.howItWorks?.bannerImage}
                              />
                            )}
                          />
                          {errors.howItWorks?.bannerImage && (
                            <span className="text-danger">
                              {errors.howItWorks.bannerImage.message}
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Title
                          </label>
                          <input
                            type="text"
                            {...register("howItWorks.title", {
                              required: "Please enter title",
                            })}
                            className={`form-control ${errors.howItWorks?.title ? "is-invalid" : ""
                              }`}
                          />
                          {errors.howItWorks?.title && (
                            <span className="text-danger">
                              {errors.howItWorks.title.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Steps
                        </h4>
                      </Col>

                      {/* How It Works: Step Work Array */}
                      {stepFields.map((field, index) => (
                        <div key={field.id} className="row">
                          {/* Step Work: Logo */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Step Logo
                              </label>
                              <Controller
                                name={`howItWorks.stepWork.${index}.logo`}
                                control={control}
                                rules={{ required: "Please enter logo" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`howItWorks.stepWork.${index}.logo`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors.howItWorks?.stepWork?.[index]?.logo}
                                  />
                                )}
                              />
                              {errors.howItWorks?.stepWork?.[index]?.logo && (
                                <span className="text-danger">
                                  {errors.howItWorks.stepWork[index].logo.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Step Work: Title */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Step Title
                              </label>
                              <input
                                type="text"
                                {...register(`howItWorks.stepWork.${index}.title`, {
                                  required: "Please enter step title",
                                })}
                                className={`form-control ${errors.howItWorks?.stepWork?.[index]?.title
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.howItWorks?.stepWork?.[index]?.title && (
                                <span className="text-danger">
                                  {errors.howItWorks.stepWork[index].title.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Step Work: Description */}
                          {/* <Col lg="4" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Step Description
                              </label>
                              <input
                                type="text"
                                {...register(`howItWorks.stepWork.${index}.desc`, {
                                  required: "Please enter step description",
                                })}
                                className={`form-control ${errors.howItWorks?.stepWork?.[index]?.desc
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.howItWorks?.stepWork?.[index]?.desc && (
                                <span className="text-danger">
                                  {errors.howItWorks.stepWork[index].desc.message}
                                </span>
                              )}
                            </div>
                          </Col> */}

                          <Col lg="12" md="4" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Step Description
                              </label>

                              <Controller
                                name={`howItWorks.stepWork.${index}.desc`}
                                control={control}
                                rules={{ required: "Please enter a step description" }}
                                render={({ field }) => (
                                  <CKEditorNew
                                    field={field.name}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.howItWorks?.stepWork?.[index]?.desc}
                                    placeholder="Type your description here..."
                                  />
                                )}
                              />

                              {errors?.howItWorks?.stepWork?.[index]?.description && (
                                <span className="text-danger">
                                  {errors.howItWorks?.stepWork[index].description.message}
                                </span>
                              )}
                            </div>
                          </Col>


                          {/* Remove Step Button */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeStep(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}

                      {/* Add Step Button */}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => appendStep({ logo: "", title: "", desc: "" })}
                        >
                          <MdAdd style={{ marginBottom: "2px" }} />
                          Step
                        </Button>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="whyChooseUs">
                    <Row>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Why Choose Us Section
                        </h4>
                      </Col>

                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Why Choose Us Title
                          </label>
                          <input
                            type="text"
                            {...register("whyChooseUs.title", {
                              required: "Please enter why choose us title",
                            })}
                            className={`form-control ${errors.whyChooseUs?.title ? "is-invalid" : ""
                              }`}
                          />
                          {errors.whyChooseUs?.title && (
                            <span className="text-danger">
                              {errors.whyChooseUs.title.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      {/* Why Choose Us: SubTitle */}
                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Why Choose Us SubTitle
                          </label>
                          <input
                            type="text"
                            {...register("whyChooseUs.subTitle", {
                              required: "Please enter why choose us sub title",
                            })}
                            className={`form-control ${errors.whyChooseUs?.subTitle ? "is-invalid" : ""
                              }`}
                          />
                          {errors.whyChooseUs?.subTitle && (
                            <span className="text-danger">
                              {errors.whyChooseUs.subTitle.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Cards
                        </h4>
                      </Col>
                      {/* Why Choose Us: Card Array */}
                      {cardFields.map((field, index) => (
                        <div key={field.id} className="row">
                          {/* Card: Image */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Card Image
                              </label>
                              <Controller
                                name={`whyChooseUs.card.${index}.image`}
                                control={control}
                                rules={{ required: "Please upload an image" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`whyChooseUs.card.${index}.image`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors.whyChooseUs?.card?.[index]?.image}
                                  />
                                )}
                              />
                              {errors.whyChooseUs?.card?.[index]?.image && (
                                <span className="text-danger">
                                  {errors.whyChooseUs.card[index].image.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Card: Title */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Card Title
                              </label>
                              <input
                                type="text"
                                {...register(`whyChooseUs.card.${index}.title`, {
                                  required: "Please enter card title",
                                })}
                                className={`form-control ${errors.whyChooseUs?.card?.[index]?.title
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.whyChooseUs?.card?.[index]?.title && (
                                <span className="text-danger">
                                  {errors.whyChooseUs.card[index].title.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Card: Description */}
                          {/* <Col lg="4" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Card Description
                    </label>
                    <input
                      type="text"
                      {...register(`whyChooseUs.card.${index}.desc`, {
                        required: "Please enter card description",
                      })}
                      className={`form-control ${errors.whyChooseUs?.card?.[index]?.desc
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {errors.whyChooseUs?.card?.[index]?.desc && (
                      <span className="text-danger">
                        {errors.whyChooseUs.card[index].desc.message}
                      </span>
                    )}
                  </div>
                            </Col> */}

                          <Col lg="12" md="12" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Card Description
                              </label>

                              <Controller
                                name={`whyChooseUs.card.${index}.desc`}
                                control={control}
                                rules={{ required: "Please enter a card description" }}
                                render={({ field }) => (
                                  <CKEditorNew
                                    field={field.name}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.whyChooseUs?.card?.[index]?.desc}
                                    placeholder="Type your description here..."
                                  />
                                )}
                              />

                              {errors.whyChooseUs?.card?.[index]?.desc && (
                                <span className="text-danger">
                                  {errors.whyChooseUs.card[index].desc.message}
                                </span>
                              )}
                            </div>
                          </Col>


                          {/* Remove Card Buttonn */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeCard(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}

                      {/* Add Card Button */}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => appendCard({ image: "", title: "", desc: "" })}
                        >
                          <MdAdd />
                          Add Card
                        </Button>
                      </Col>

                    </Row>
                  </Tab.Pane>


                  <Tab.Pane eventKey="compare">
                    <Row>
                      {/* Let’s Compare: Title */}
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Let’s Compare
                        </h4>
                      </Col>
                      <Col lg="12" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Title
                          </label>
                          <input
                            type="text"
                            {...register("letCompare.title", {
                              required: "Please enter title",
                            })}
                            className={`form-control ${errors.letCompare?.title ? "is-invalid" : ""
                              }`}
                          />
                          {errors.letCompare?.title && (
                            <span className="text-danger">
                              {errors.letCompare.title.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      {/* Let’s Compare: Feature List Array */}
                      {featureFields.map((field, index) => (
                        <div key={field.id} className="row">
                          {/* Feature */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Feature
                              </label>
                              <input
                                type="text"
                                {...register(`letCompare.featureList.${index}.feature`, {
                                  required: "Please enter feature",
                                })}
                                className={`form-control ${errors.letCompare?.featureList?.[index]?.feature
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.letCompare?.featureList?.[index]?.feature && (
                                <span className="text-danger">
                                  {errors.letCompare.featureList[index].feature.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Kalofy */}
                          <Col lg="3" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Kalofy
                              </label>
                              <input
                                style={{ marginLeft: "20px", marginTop: "6px" }}
                                type="checkbox"
                                {...register(`letCompare.featureList.${index}.kalofy`)}
                                className="form-check-input"
                              />
                            </div>
                          </Col>

                          {/* Industry */}
                          <Col lg="3" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Industry
                              </label>
                              <input
                                style={{ marginLeft: "20px", marginTop: "6px" }}
                                type="checkbox"
                                {...register(`letCompare.featureList.${index}.industry`)}
                                className="form-check-input"
                              />
                            </div>
                          </Col>

                          {/* Remove Feature Button */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeFeature(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}

                      {/* Add Feature Button */}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() =>
                            appendFeature({
                              feature: "",
                              kalofy: false,
                              industry: false,
                            })
                          }
                        >
                          <MdAdd />
                          Add Feature
                        </Button>
                      </Col>

                      {/* Let’s Compare: Image Section Array */}
                      {imageFields.map((field, index) => (
                        <div key={field.id} className="row">
                          {/* Image */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Image
                              </label>
                              <Controller
                                name={`letCompare.imageSection.${index}.image`}
                                control={control}
                                rules={{ required: "Please enter image" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`letCompare.imageSection.${index}.image`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={
                                      errors.letCompare?.imageSection?.[index]?.image
                                    }
                                  />
                                )}
                              />
                              {errors.letCompare?.imageSection?.[index]?.image && (
                                <span className="text-danger">
                                  {errors.letCompare.imageSection[index].image.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Title */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Title
                              </label>
                              <input
                                type="text"
                                {...register(`letCompare.imageSection.${index}.title`, {
                                  required: "Please enter title",
                                })}
                                className={`form-control ${errors.letCompare?.imageSection?.[index]?.title
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.letCompare?.imageSection?.[index]?.title && (
                                <span className="text-danger">
                                  {errors.letCompare.imageSection[index].title.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* SubTitle */}
                          {/* <Col lg="12" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Sub title
                    </label>
                    <input
                      type="text"
                      {...register(
                        `letCompare.imageSection.${index}.subTitle`,
                        {
                          required: "Please enter sub title",
                        }
                      )}
                      className={`form-control ${errors.letCompare?.imageSection?.[index]?.subTitle
                          ? "is-invalid"
                          : ""
                        }`}
                    />
                    {errors.letCompare?.imageSection?.[index]?.subTitle && (
                      <span className="text-danger">
                        {errors.letCompare.imageSection[index].subTitle.message}
                      </span>
                    )}
                  </div>
                </Col> */}

                          {/* CaloCount */}
                          <Col lg="12" className="my-2">
                            <div className="py-2">
                              <h5 className="fw-bold">Calories Info</h5>
                            </div>
                          </Col>

                          {/* Calories */}
                          <Col lg="3" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Calories
                              </label>
                              <input
                                type="text"
                                {...register(
                                  `letCompare.imageSection.${index}.caloCount.calories`,
                                  { required: "Please enter calories" }
                                )}
                                className={`form-control ${errors.letCompare?.imageSection?.[index]?.caloCount
                                  ?.calories
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.letCompare?.imageSection?.[index]?.caloCount
                                ?.calories && (
                                  <span className="text-danger">
                                    {
                                      errors.letCompare.imageSection[index].caloCount
                                        .calories.message
                                    }
                                  </span>
                                )}
                            </div>
                          </Col>

                          {/* Fat */}
                          <Col lg="3" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Fat
                              </label>
                              <input
                                type="text"
                                {...register(
                                  `letCompare.imageSection.${index}.caloCount.fat`,
                                  { required: "Please enter fat" }
                                )}
                                className={`form-control ${errors.letCompare?.imageSection?.[index]?.caloCount?.fat
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.letCompare?.imageSection?.[index]?.caloCount
                                ?.fat && (
                                  <span className="text-danger">
                                    {
                                      errors.letCompare.imageSection[index].caloCount.fat
                                        .message
                                    }
                                  </span>
                                )}
                            </div>
                          </Col>

                          {/* Protein */}
                          <Col lg="3" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Protein
                              </label>
                              <input
                                type="text"
                                {...register(
                                  `letCompare.imageSection.${index}.caloCount.protein`,
                                  { required: "Please enter protein" }
                                )}
                                className={`form-control ${errors.letCompare?.imageSection?.[index]?.caloCount
                                  ?.protein
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.letCompare?.imageSection?.[index]?.caloCount
                                ?.protein && (
                                  <span className="text-danger">
                                    {
                                      errors.letCompare.imageSection[index].caloCount
                                        .protein.message
                                    }
                                  </span>
                                )}
                            </div>
                          </Col>

                          {/* Carbs */}
                          <Col lg="3" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Carbs
                              </label>
                              <input
                                type="text"
                                {...register(
                                  `letCompare.imageSection.${index}.caloCount.carbs`,
                                  { required: "Please enter carbs" }
                                )}
                                className={`form-control ${errors.letCompare?.imageSection?.[index]?.caloCount
                                  ?.carbs
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.letCompare?.imageSection?.[index]?.caloCount
                                ?.carbs && (
                                  <span className="text-danger">
                                    {
                                      errors.letCompare.imageSection[index].caloCount.carbs
                                        .message
                                    }
                                  </span>
                                )}
                            </div>
                          </Col>

                          {/* Remove Image Section */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeImage(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}

                      {/* Add Image Button */}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() =>
                            appendImage({
                              image: "",
                              title: "",
                              // subTitle: "",
                              caloCount: {
                                calories: "",
                                fat: "",
                                protein: "",
                                carbs: "",
                              },
                            })
                          }
                        >
                          <MdAdd />
                          Add Image
                        </Button>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="kitchenDelivery">
                    <Row>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Kitchen Delivery
                        </h4>
                      </Col>

                      {/* Title */}
                      <Col lg="6" className="my-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Title
                        </label>
                        <input
                          type="text"
                          {...register("kitchenDelivery.title", {
                            required: "Title is required",
                          })}
                          className={`form-control ${errors.kitchenDelivery?.title ? "is-invalid" : ""
                            }`}
                        />
                        {errors.kitchenDelivery?.title && (
                          <span className="text-danger">
                            {errors.kitchenDelivery.title.message}
                          </span>
                        )}
                      </Col>

                      {/* Subtitle */}
                      <Col lg="6" className="my-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Sub title
                        </label>
                        <input
                          type="text"
                          {...register("kitchenDelivery.subTitle", {
                            required: "Sub title is required",
                          })}
                          className={`form-control ${errors.kitchenDelivery?.subTitle ? "is-invalid" : ""
                            }`}
                        />
                        {errors.kitchenDelivery?.subTitle && (
                          <span className="text-danger">
                            {errors.kitchenDelivery.subTitle.message}
                          </span>
                        )}
                      </Col>

                      {/* Image */}
                      <Col lg="6" className="my-2">
                        <Controller
                          name="kitchenDelivery.image"
                          control={control}
                          rules={{ required: "Image is required" }}
                          render={({ field }) => (
                            <Dropzone
                              {...field}
                              field={`kitchenDelivery.image`}
                              setFieldValue={setValue}
                              value={field.value}
                              error={errors?.kitchenDelivery?.image}
                            />
                          )}
                        />
                        {errors.kitchenDelivery?.image && (
                          <span className="text-danger">
                            {errors.kitchenDelivery.image.message}
                          </span>
                        )}
                      </Col>



                      <Col lg="6" className="my-2">
                        <Controller
                          name="kitchenDelivery.video"
                          control={control}
                          rules={{ required: "Image is required" }}
                          render={({ field }) => (
                            <Dropzone
                              {...field}
                              field={`kitchenDelivery.video`}
                              setFieldValue={setValue}
                              value={field.value}
                              error={errors?.kitchenDelivery?.video}
                            />
                          )}
                        />
                        {errors.kitchenDelivery?.video && (
                          <span className="text-danger">
                            {errors.kitchenDelivery.video.message}
                          </span>
                        )}
                      </Col>

                      {/* Video */}
                      {/* <Col lg="12" className="my-2">
              <label className="form-label fw-sbold text-muted ps-2 m-0">
                Video title
              </label>
              <input
                type="text"
                {...register("kitchenDelivery.video", {
                  required: "Video title is required",
                })}
                className={`form-control ${
                  errors.kitchenDelivery?.video ? "is-invalid" : ""
                }`}
              />
              {errors.kitchenDelivery?.video && (
                <span className="text-danger">
                  {errors.kitchenDelivery.video.message}
                </span>
              )}
                         </Col> */}

                      {/* List */}
                      <Col lg="12" className="my-2">
                        <div>
                          <h5 className="fw-bold">List Items</h5>
                          {listFields.map((item, index) => (
                            <div key={item.id}>

                              <div className="py-2">
                                <label className="form-label fw-sbold text-muted ps-2 m-0">
                                  List
                                </label>
                                <input
                                  type="text"
                                  {...register(`kitchenDelivery.list.${index}`, {
                                    required: "Item is required",
                                  })}
                                  className={`form-control ${errors.kitchenDelivery?.list?.[index]
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                />
                                {errors.kitchenDelivery?.list?.[index] && (
                                  <span className="text-danger">
                                    {errors.kitchenDelivery.list[index].message}
                                  </span>
                                )}
                              </div>


                              <Button
                                type="button"
                                variant="danger"
                                onClick={() => removeList(index)}
                              >
                                <MdDelete />
                              </Button>
                            </div>
                          ))}

                          <Button type="button" style={{ marginTop: "10px" }} onClick={() => appendList("")}>
                            <MdAdd />
                            Add Item
                          </Button>
                        </div>
                      </Col>

                      {/* Week */}
                      <h5 className="fw-bold">Week Info</h5>
                      {weekFields.map((item, index) => (
                        <div key={item.id} className="row">
                          {/* Week Name */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Week Day Name
                              </label>
                              <input
                                placeholder="Enter week day name"
                                type="text"
                                {...register(`kitchenDelivery.week.${index}.name`, {
                                  required: "Please enter week day name",
                                })}
                                className={`form-control ${errors.kitchenDelivery?.week?.[index]?.name
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.kitchenDelivery?.week?.[index]?.name && (
                                <span className="text-danger">
                                  {errors.kitchenDelivery.week[index].name.message}
                                </span>
                              )}
                            </div>
                          </Col>
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Image
                              </label>
                              {/* Week Image */}
                              <Controller
                                name={`kitchenDelivery.week.${index}.image`}
                                control={control}
                                rules={{ required: "Image is required" }}
                                render={({ field }) => (
                                  <Dropzone
                                    {...field}
                                    field={`kitchenDelivery.week.${index}.image`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors.kitchenDelivery?.week?.[index]?.image}
                                  />
                                )}
                              />
                              {errors.kitchenDelivery?.week?.[index]?.image && (
                                <span className="text-danger">
                                  {errors.kitchenDelivery.week[index].image.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          <Col lg="4" className="my-2">
                            {/* Enable */}
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Enable
                              </label>
                              <input
                                style={{ marginLeft: "20px", marginBottom: "5px" }}
                                type="checkbox"
                                {...register(`kitchenDelivery.week.${index}.enable`)}
                              />
                            </div>
                          </Col>

                          <Col lg="4" className="text-right">
                            <Button
                              style={{ marginLeft: "500px" }}
                              type="button"
                              variant="danger"
                              onClick={() => removeWeek(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}
                      <Col lg="3" className="my-2">
                        <Button
                          type="button"
                          onClick={() =>
                            appendWeek({ name: "", image: "", enable: false })
                          }
                        >
                          <MdAdd />
                          Add Week
                        </Button>
                      </Col>
                    </Row>
                  </Tab.Pane>


                  <Tab.Pane eventKey="customerTestimonials">
                    <Row>
                      {/* Customer Testimonials: Title */}
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Customer Testimonials
                        </h4>
                      </Col>


                      <Col lg="6" className="my-2">
                        <Controller
                          name="testimonial.image"
                          control={control}
                          rules={{ required: "Image is required" }}
                          render={({ field }) => (
                            <Dropzone
                              {...field}
                              field={`testimonial.image`}
                              setFieldValue={setValue}
                              value={field.value}
                              error={errors?.testimonial?.image}
                            />
                          )}
                        />
                        {errors.testimonial?.image && (
                          <span className="text-danger">
                            {errors.testimonial.image.message}
                          </span>
                        )}
                      </Col>

                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Title
                          </label>
                          <input
                            type="text"
                            placeholder="Enter title"
                            {...register("testimonial.title", {
                              required: "Title is required",
                            })}
                            className={`form-control ${errors.testimonial?.title ? "is-invalid" : ""
                              }`}
                          />
                          {errors.testimonial?.title && (
                            <span className="text-danger">
                              {errors.testimonial?.title?.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      {/* Map through each testimonial and render form fields */}
                      {testimonialFields.map((field, index) => (
                        <div key={field.id} className="row">
                          {/* Description */}
                          {/* <Col lg="12" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Description
                    </label>
                    <input
                      placeholder="Enter description"
                      type="text"
                      {...register(`testimonial.testimonial.${index}.desc`, {
                        required: "Description is required",
                      })}
                      className={`form-control ${errors.testimonial?.testimonial?.[index]?.desc
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {errors.testimonial?.testimonial?.[index]?.desc && (
                      <span className="text-danger">
                        {
                          errors.testimonial?.testimonial?.[index]?.desc
                            ?.message
                        }
                      </span>
                    )}
                  </div>
                </Col> */}

                          <Col lg="12" md="12" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Description
                              </label>

                              <Controller
                                name={`testimonial.testimonial.${index}.desc`}
                                control={control}
                                rules={{ required: "Please enter a description" }}
                                render={({ field }) => (
                                  <CKEditorNew
                                    field={field.name}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors?.testimonial?.testimonial?.[index]?.desc}
                                    placeholder="Type your description here..."
                                  />
                                )}
                              />

                              {errors?.testimonial?.testimonial?.[index]?.desc && (
                                <span className="text-danger">
                                  {errors.testimonial?.testimonial[index].desc.message}
                                </span>
                              )}
                            </div>
                          </Col>








                          {/* Image */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Image
                              </label>
                              <Controller
                                name={`testimonial.testimonial.${index}.image`}
                                control={control}
                                rules={{ required: "Image is required" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`testimonial.testimonial.${index}.image`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={
                                      errors.testimonial?.testimonial?.[index]?.image
                                    }
                                  />
                                )}
                              />
                              {errors.testimonial?.testimonial?.[index]?.image && (
                                <span className="text-danger">
                                  {
                                    errors.testimonial?.testimonial?.[index]?.image
                                      ?.message
                                  }
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* User Name */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                User Name
                              </label>
                              <input
                                placeholder="Enter username"
                                type="text"
                                {...register(
                                  `testimonial.testimonial.${index}.userName`,
                                  {
                                    required: "User name is required",
                                  }
                                )}
                                className={`form-control ${errors.testimonial?.testimonial?.[index]?.userName
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.testimonial?.testimonial?.[index]?.userName && (
                                <span className="text-danger">
                                  {
                                    errors.testimonial?.testimonial?.[index]?.userName
                                      ?.message
                                  }
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Member */}
                          {/* <Col lg="6" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Member Status
                    </label>
                    <select
                      {...register(`testimonial.testimonial.${index}.member`, {
                        required: "Member status is required",
                      })}
                      className={`form-control ${
                        errors.testimonial?.testimonial?.[index]?.member
                          ? "is-invalid"
                          : ""
                      }`}
                    >
                      <option value="Member">Member</option>
                      <option value="No_Member">Non-Member</option>
                    </select>
                    {errors.testimonial?.testimonial?.[index]?.member && (
                      <span className="text-danger">
                        {
                          errors.testimonial?.testimonial?.[index]?.member
                            ?.message
                        }
                      </span>
                    )}
                  </div>
                </Col> */}

                          {/* Rating */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Rating
                              </label>
                              <input
                                placeholder="Enter rating"
                                type="number"
                                {...register(`testimonial.testimonial.${index}.rating`, {
                                  required: "Rating is required",
                                  min: {
                                    value: 1,
                                    message: "Minimum rating is 1",
                                  },
                                  max: {
                                    value: 5,
                                    message: "Maximum rating is 5",
                                  },
                                })}
                                className={`form-control ${errors.testimonial?.testimonial?.[index]?.rating
                                  ? "is-invalid"
                                  : ""
                                  }`}
                              />
                              {errors.testimonial?.testimonial?.[index]?.rating && (
                                <span className="text-danger">
                                  {
                                    errors.testimonial?.testimonial?.[index]?.rating
                                      ?.message
                                  }
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Remove Testimonial Section */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeTestimonial(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}

                      {/* Add new testimonial button */}
                      <Col lg="12" className="text-right my-3">
                        <Button
                          type="button"
                          variant="primary"
                          onClick={() =>
                            appendTestimonial({
                              desc: "",
                              image: "",
                              userName: "",
                              member: "Member",
                              rating: 1,
                            })
                          }
                        >
                          Add New Testimonial
                        </Button>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="socialMedia">
                    <Row>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Follow Us on Social Media
                        </h4>
                      </Col>

                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Main Title
                          </label>
                          <input
                            type="text"
                            {...register("subscribe.title", {
                              required: "Title is required",
                            })}
                            className={`form-control ${errors.subscribe?.followUs?.title ? "is-invalid" : ""
                              }`}
                          />
                          {errors.subscribe?.title && (
                            <span className="text-danger">
                              {errors.subscribe?.title?.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Title
                          </label>
                          <input
                            type="text"
                            {...register("subscribe.followUs.title", {
                              required: "Title is required",
                            })}
                            className={`form-control ${errors.subscribe?.followUs?.title ? "is-invalid" : ""
                              }`}
                          />
                          {errors.subscribe?.followUs?.title && (
                            <span className="text-danger">
                              {errors.subscribe?.followUs?.title?.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col lg="12" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Description
                          </label>
                          <input
                            type="text"
                            {...register("subscribe.followUs.desc", {
                              required: "Description is required",
                            })}
                            className={`form-control ${errors.subscribe?.followUs?.desc ? "is-invalid" : ""
                              }`}
                          />
                          {errors.subscribe?.followUs?.desc && (
                            <span className="text-danger">
                              {errors.subscribe?.followUs?.desc?.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      {/* Social Media Iconss */}
                      <Col lg="12">
                        <h5 className="py-2">Social Media Icons</h5>
                        {iconFields.map((field, index) => (
                          <div key={field.id} className="row">
                            <Col lg="4" className="my-2">
                              <div className="py-2">
                                <label className="form-label fw-sbold text-muted ps-2 m-0">
                                  Icon {index + 1}
                                </label>
                                <Controller
                                  name={`subscribe.followUs.socialIcon.${index}.icon`}
                                  control={control}
                                  render={({ field }) => (
                                    <Dropzone
                                      field={`subscribe.followUs.socialIcon.${index}.icon`}
                                      setFieldValue={setValue}
                                      value={field.value}
                                      error={
                                        errors.subscribe?.followUs?.socialIcon?.[index]
                                          ?.icon
                                      }
                                    />
                                  )}
                                />
                                {errors.subscribe?.followUs?.socialIcon?.[index]
                                  ?.icon && (
                                    <span className="text-danger">
                                      {
                                        errors.subscribe?.followUs?.socialIcon?.[index]
                                          ?.icon?.message
                                      }
                                    </span>
                                  )}
                              </div>
                            </Col>

                            <Col lg="6" className="my-2">
                              <div className="py-2">
                                <label className="form-label fw-sbold text-muted ps-2 m-0">
                                  Link
                                </label>
                                <input
                                  type="text"
                                  {...register(
                                    `subscribe.followUs.socialIcon.${index}.iconLinks`,
                                    {
                                      required: "Link is required",
                                    }
                                  )}
                                  className={`form-control ${errors.subscribe?.followUs?.socialIcon?.[index]
                                    ?.iconLinks
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                />
                                {errors.subscribe?.followUs?.socialIcon?.[index]
                                  ?.iconLinks && (
                                    <span className="text-danger">
                                      {
                                        errors.subscribe?.followUs?.socialIcon?.[index]
                                          ?.iconLinks?.message
                                      }
                                    </span>
                                  )}
                              </div>
                            </Col>

                            <Col lg="2" className="my-2 d-flex align-items-center">
                              <Button
                                style={{ marginBottom: "90px" }}
                                type="button"
                                variant="danger"
                                onClick={() => removeSubIcon(index)}
                                className="mt-2"
                              >
                                <MdDelete />
                              </Button>
                            </Col>
                          </div>
                        ))}
                        <Button
                          type="button"
                          variant="primary"
                          onClick={() => appendSubIcon({ icon: "", iconLinks: "" })}
                          className="mt-3"
                        >
                          Add New Icon
                        </Button>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="newsLetter">
                    <Row>
                      {/* Subscribe to Newsletter Section */}
                      <Col lg="12" className="mt-4">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Subscribe to Our Newsletter
                        </h4>
                      </Col>

                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Title
                          </label>
                          <input
                            type="text"
                            {...register("subscribe.subscribe.title", {
                              required: "Title is required",
                            })}
                            className={`form-control ${errors.subscribe?.subscribe?.title ? "is-invalid" : ""
                              }`}
                          />
                          {errors.subscribe?.subscribe?.title && (
                            <span className="text-danger">
                              {errors.subscribe?.subscribe?.title?.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Description
                          </label>
                          <textarea
                            type="text"
                            {...register("subscribe.subscribe.desc", {
                              required: "Description is required",
                            })}
                            className={`form-control ${errors.subscribe?.subscribe?.desc ? "is-invalid" : ""
                              }`}
                          />
                          {errors.subscribe?.subscribe?.desc && (
                            <span className="text-danger">
                              {errors.subscribe?.subscribe?.desc?.message}
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>


                  <Tab.Pane eventKey="footerSettings">
                    <Row>
                      {/* Footer Section */}
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Footer Settings
                        </h4>
                      </Col>


                      {/* Footer: atmCardImages */}
                      {stepFooter.map((field, index) => (
                        <div key={field.id} className="row">
                          <Col lg="12" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Card images
                              </label>
                              <Controller
                                name={`footer.atmCard.${index}.image`}
                                control={control}
                                rules={{ required: "Please enter card image" }}
                                render={({ field }) =>{console.log(field,'field')
                                return (
                                  
                                  
                                  <Dropzone
                                    field={`footer.atmCard.${index}.image`}
                                    setFieldValue={setValue}
                                    value={field.value}
                                    error={errors.footer?.atmCard?.[index]?.image}
                                  />
                                )}}
                              />
                              {errors.footer?.atmCard?.[index]?.image && (
                                <span className="text-danger">
                                  {errors.footer.atmCard[index].image.message}
                                </span>
                              )}
                            </div>
                          </Col>




                          {/* Remove Step Button */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removeFooter(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}

                      {/* Add footer image */}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => appendFooter({ image: "", })}
                        >
                          <MdAdd style={{ marginBottom: "2px" }} />
                          Add footer card image
                        </Button>
                      </Col>

                      {/* We accept */}
                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            We Accept Text
                          </label>
                          <input
                            type="text"
                            {...register("footer.weAccept", {
                              required: "We accept text is required",
                            })}
                            className={`form-control ${errors.footer?.weAccept ? "is-invalid" : ""
                              }`}
                          />
                          {errors.footer?.weAccept && (
                            <span className="text-danger">
                              {errors.footer?.weAccept?.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      {/* Copyright Text */}
                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Copyright Text
                          </label>
                          <input
                            type="text"
                            {...register("footer.copyrightText", {
                              required: "Copyright text is required",
                            })}
                            className={`form-control ${errors.footer?.copyrightText ? "is-invalid" : ""
                              }`}
                          />
                          {errors.footer?.copyrightText && (
                            <span className="text-danger">
                              {errors.footer?.copyrightText?.message}
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Tab.Pane>

                  {/* Terms and Conditions Link */}
                  {/* <Col lg="12" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                  Terms & Conditions Link
                </label>
                <input
                  type="url"
                  {...register("footer.termAndConditionLink", {
                    required: "Terms and Conditions link is required",
                  })}
                  className={`form-control ${errors.footer?.termAndConditionLink ? "is-invalid" : ""
                    }`}
                />
                {errors.footer?.termAndConditionLink && (
                  <span className="text-danger">
                    {errors.footer?.termAndConditionLink?.message}
                  </span>
                )}
              </div>
            </Col> */}

                  <Tab.Pane eventKey="trustedPartners">
                    <Row>
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Trusted Partners Section
                        </h4>
                      </Col>

                      {/* Title */}
                      <Col lg="6" className="my-2">
                        <div className="py-2">
                          <label className="form-label fw-sbold text-muted ps-2 m-0">
                            Trusted Partners Title
                          </label>
                          <input
                            type="text"
                            {...register("trustedPartners.title", {
                              required: "Please enter trusted partners title",
                            })}
                            className={`form-control ${errors.trustedPartners?.title ? "is-invalid" : ""}`}
                          />
                          {errors.trustedPartners?.title && (
                            <span className="text-danger">
                              {errors.trustedPartners.title.message}
                            </span>
                          )}
                        </div>
                      </Col>

                      {/* Partners List */}
                      <Col lg="12">
                        <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                          Partners List
                        </h4>
                      </Col>

                      {partnerFields.map((field, index) => (
                        <div key={field.id} className="row border p-3 my-2 rounded">

                          {/* Partner Image */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Partner Logo
                              </label>
                              <Controller
                                name={`trustedPartners.partners.${index}.image`}
                                control={control}
                                rules={{ required: "Please upload an image" }}
                                render={({ field }) => (
                                  <Dropzone
                                    field={`trustedPartners.partners.${index}.image`}
                                    setFieldValue={(fieldName, value) => {
                                      // If Dropzone returns an array, use only the first item
                                      const finalValue = Array?.isArray(value) ? value?.[0] : value;
                                      setValue(fieldName, finalValue);
                                    }}
                                    value={field?.value}
                                    error={errors?.trustedPartners?.partners?.[index]?.image}
                                    maxFiles={1} // optional: limit Dropzone to one file
                                  />
                                )}
                              />
                              {errors?.trustedPartners?.partners?.[index]?.image && (
                                <span className="text-danger">
                                  {errors.trustedPartners.partners[index].image.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Partner Status */}
                          <Col lg="6" className="my-2">
                            <div className="py-2">
                              <label className="form-label fw-sbold text-muted ps-2 m-0">
                                Status
                              </label>
                              <select
                                {...register(`trustedPartners.partners.${index}.status`, {
                                  required: "Please select status",
                                })}
                                className={`form-control ${errors.trustedPartners?.partners?.[index]?.status ? "is-invalid" : ""}`}
                              >
                                <option value="">Select Status</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </select>
                              {errors?.trustedPartners?.partners?.[index]?.status && (
                                <span className="text-danger">
                                  {errors.trustedPartners.partners[index].status.message}
                                </span>
                              )}
                            </div>
                          </Col>

                          {/* Remove Button */}
                          <Col lg="12" className="text-right">
                            <Button
                              type="button"
                              variant="danger"
                              onClick={() => removePartner(index)}
                              className="mt-2"
                            >
                              <MdDelete />
                            </Button>
                          </Col>
                        </div>
                      ))}

                      {/* Add Partner Button */}
                      <Col lg="12" className="text-right mt-3">
                        <Button
                          type="button"
                          color="primary"
                          onClick={() =>
                            appendPartner({ image: "", status: "" })
                          }
                        >
                          <MdAdd /> Add Partner
                        </Button>
                      </Col>
                    </Row>
                  </Tab.Pane>



                  {/* Submit Button */}
                  <Col lg="12" className="text-right my-3">
                    <Button
                      type="submit"
                      className="d-flex align-items-center justify-content-center commonBtn"
                      disabled={isUpdating}
                    >
                      Submit
                    </Button>
                  </Col>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </div>
      </form>
    </Col>
  );
}

export default HomepageContentForm;
